import { AfFilter, AfFilterGridData } from './afFilter.types';

export function adaptToCreate(
  afFilter: AfFilterGridData,
): AfFilter {
  return {
    afId: afFilter.afName || '',
    fgId: afFilter.fgName || ''
  }
}
